const postalCodeRegex =
	/(^[\d]{5}$)|(^[A-CEGHJ-NPR-TVX]\d[A-CEGHJ-NP-TV-XZ]\s\d[A-CEGHJ-NPR-TV-XZ]\d$)/i;

/**
 * @param {string} value
 * @returns {string}
 */
function normalizePostalCode(value) {
	const trimmedValue = value.trim();
	const zipCodeMatch = trimmedValue.match(/^(\d{3,5})(?:-\d{4})?$/);

	if (zipCodeMatch) {
		return zipCodeMatch[1].padStart(5, '0');
	}

	const canadianPostalCode = trimmedValue.toUpperCase().replace(/\s+/g, '');

	if (
		/^[A-CEGHJ-NPR-TVX]\d[A-CEGHJ-NPR-TV-XZ]\d[A-CEGHJ-NPR-TV-XZ]\d$/.test(
			canadianPostalCode
		)
	) {
		return `${canadianPostalCode.slice(0, 3)} ${canadianPostalCode.slice(
			3
		)}`;
	}

	return trimmedValue;
}

/**
 * @param {string | null | undefined} value
 * @returns {string[]}
 */
export function parsePostalCodeList(value) {
	if (typeof value !== 'string') {
		return [];
	}

	return Array.from(
		new Set(
			value
				.split(/[\n,]+/)
				.map(normalizePostalCode)
				.filter(Boolean)
		)
	);
}

/**
 * @param {string | null | undefined} value
 * @returns {boolean}
 */
export function isValidPostalCode(value) {
	return typeof value === 'string' && postalCodeRegex.test(value.trim());
}

/**
 * @param {string | null | undefined} value
 * @returns {string}
 */
export function normalizePostalCodeList(value) {
	return parsePostalCodeList(value).join(', ');
}
